import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { LearningSessionHistory } from 'app/types';
import { modeById } from 'pages/Learning/learningMeta';
import FilledActionButton from 'components/FilledActionButton';

interface LearningContinueBannerProps {
  session: LearningSessionHistory;
  onContinue: () => void;
  starting?: boolean;
}

const LearningContinueBanner: React.FC<LearningContinueBannerProps> = ({
  session,
  onContinue,
  starting,
}) => {
  const mode = modeById(session.mode);
  const total = Math.max(session.wordsCount || 0, 1);

  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: 'primary.main',
        borderRadius: 2,
        boxShadow: '0 14px 34px -24px rgba(59,44,147,0.45)',
        p: { xs: 2.5, md: '24px 28px' },
      }}
    >
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        alignItems={{ xs: 'stretch', md: 'center' }}
        justifyContent={'space-between'}
        spacing={{ xs: 2, md: 3.5 }}
      >
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Stack
            direction={'row'}
            alignItems={'center'}
            spacing={1}
            sx={{ mb: 0.75 }}
          >
            <Box
              sx={{
                bgcolor: 'primary.main',
                borderRadius: '50%',
                height: 8,
                width: 8,
              }}
            />
            <Typography
              sx={{
                color: 'primary.main',
                fontSize: 12,
                fontWeight: 800,
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
              }}
            >
              {'Незавершена сесія'}
            </Typography>
          </Stack>
          <Typography
            sx={{
              fontSize: { xs: 18, md: 22 },
              fontWeight: 800,
              lineHeight: 1.2,
              mb: 0.5,
            }}
          >
            {'Продовжити вправи'}
          </Typography>
          <Typography sx={{ color: 'text.secondary', fontSize: 14 }}>
            {`Режим «${mode?.label ?? session.mode}» · ${total} слів у сесії`}
          </Typography>
        </Box>

        <Stack
          direction={'row'}
          spacing={1.25}
          sx={{ flex: 'none', flexWrap: 'wrap', rowGap: 1 }}
        >
          <FilledActionButton
            startIcon={<PlayArrowIcon />}
            onClick={onContinue}
            disabled={starting}
            sx={{ fontSize: 14, height: 44, px: 2.5 }}
          >
            {'Продовжити'}
          </FilledActionButton>
        </Stack>
      </Stack>
    </Box>
  );
};

export default LearningContinueBanner;
